import * as React from "react";
const SvgHomeActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m20.041 6.818-5.76-4.03c-1.57-1.1-3.98-1.04-5.491.13l-5.01 3.91c-1 .78-1.79 2.38-1.79 3.64v6.901C1.99 19.92 4.06 22 6.61 22H17.39c2.55 0 4.62-2.07 4.62-4.62v-6.781c0-1.35-.87-3.01-1.97-3.78M12.751 18c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75s.75.34.75.75z"
    />
  </svg>
);
export default SvgHomeActive;
